import {useEffect, useState} from "react";
import FunctionsData from "../../../Functions/FunctionsData";
import {Button, TableCell, TableRow} from "@mui/material";
import moment from "moment/moment";
import ConfirmDeleteDialog from "../../ConfirmDeleteDialog";
import {MdCheckCircle, MdOutlineCancel} from "react-icons/md";
import * as React from "react";

export default function StaffVetRegistrationsShowTableRow({row, dataCampaign, setLoading, setLoadingApproved, setLoadingSuccess}) {

    const [approvalOpen, setApprovalOpen] = useState(false);
    const [deleteRegOpen, setDeleteRegOpen] = useState(false);
    const [migrationOpen, setMigrationOpen] = useState(false);
    const [capacity, setCapacity] = useState([]);
    const [campaignText, setCampaignText] = useState('');

    useEffect(() => {

        let ct = '';
        let allCount = 0;
        const camp = String(row.campaigns).split(',');
        camp.forEach((c) => {
            try {
                const c1 = dataCampaign.find(({id}) => String(id) ===  String(c));
                ct = ct + ((allCount > 0) ? ', ' : '') + c1.name;
                allCount += 1;
            } catch (e) {
                console.log(e)
            }
        })
        setCampaignText(ct);

        try {
            let d = JSON.parse(row.capacity);
            setCapacity(d.filter(({selected}) => selected > 0));
        } catch (e) {
            setCapacity([]);
        }

    }, []);

    function approveVet() {

        FunctionsData.postData(
            FunctionsData.getApiUrl('/api/register/approve'),
            {
                id: row.id,
                "campaign": (campaignText === '') ? "Not available at this time" : campaignText,
                "clinic_name": row.business_name,
                "clinic_address": row.formatted_address,
                "contact_name": row.accepted_declaration_name,
                "contact_email": row.email,
                "clinic_invoiced": row.invoiced,
                "accepted_declaration_position": row.accepted_declaration_position,
                "origin": window.location.origin,
                "uuid": row.uuid,
                "registration_type": row.accepted_type,
            }
        ).then((r) => {
            setLoading(true);
            setLoadingApproved(true);
            setLoadingSuccess(true);
            setApprovalOpen(false);
        })

    }

    function migrateVet() {

        FunctionsData.postData(
            FunctionsData.getApiUrl('/api/register/migrate'),
            {
                id: row.id
            }
        ).then((r1) => {
            FunctionsData.postData(
                FunctionsData.getApiUrl('/api/register/approve-ok'),
                {
                    id: row.id,
                    contact_email:row.contact_email,
                    eoi:row.eoi
                })
                .then((r) => {
                    setLoading(true);
                    setLoadingApproved(true);
                    setLoadingSuccess(true);
                    setMigrationOpen(false);
                })
        })
    }

    function deleteReg() {
        FunctionsData.postData(
            FunctionsData.getApiUrl('/api/register/delete/')+row.id,
            {deleted:1}
        )
            .then(() => {
                setLoading(true);
                setLoadingApproved(true);
                setLoadingSuccess(true);
                setDeleteRegOpen(true);
            })
    }

    return (
        <TableRow>
            <TableCell align="left">{row.business_name}</TableCell>
            <TableCell align="left">
                <div>{row.accepted_declaration_name}</div>
                <div>{row.accepted_declaration_position}</div>
                <div>{(row.contact_email !== null) ? row.contact_email : row.email}</div>
                <div>{row.phone}</div>
            </TableCell>
            <TableCell align="left">
                <div>{row.street_number} {String(row.street).replace('undefined','')}</div>
                <div>{row.suburb}</div>
                <div>{row.city}</div>
                <div>{row.postcode}</div>
            </TableCell>
            <TableCell align="left">
                <div>{moment(row.created_at).format('DD/MM/YYYY')}</div>
                <div>Campaigns: {(row.eoi > 0) ? "EOI" : (campaignText.trim() === '') ? 'n/a' : campaignText}</div>
                <div>
                    <Button variant={"contained"} size={"small"} onClick={() => setDeleteRegOpen(true)}>
                        Delete registration
                    </Button>
                    {
                        (deleteRegOpen) ?
                            <ConfirmDeleteDialog open={deleteRegOpen} setOpen={setDeleteRegOpen} fn={deleteReg}/>
                            : null
                    }
                </div>
            </TableCell>
            <TableCell align="left">
                {
                    capacity.map((cap, index) => {
                        return (
                            <div key={index} style={{
                                boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
                                padding: 20
                            }}>
                                <h5>{cap.label}</h5>
                                <strong>Min. weight:&nbsp;</strong>{cap.minimum_weight}, <strong>Min.
                                age:&nbsp;</strong>{cap.minimum_age}<br/>
                                <strong>Capacity spay:&nbsp;</strong>{cap.day_capacity_spay}<br/>
                                <strong>Capacity neuter:&nbsp;</strong>{cap.day_capacity_neuter}<br/>
                            </div>
                        )
                    })
                }
            </TableCell>
            <TableCell align="center">
                <div>
                    {
                        (row.approved_at !== null) ?
                            <MdCheckCircle size={24}/>
                            :
                            <Button variant={"contained"} onClick={() => setApprovalOpen(true)}>Approve</Button>
                    }
                    {
                        (approvalOpen === true) ?
                            <ConfirmDeleteDialog open={approvalOpen} setOpen={setApprovalOpen}
                                                 fn={approveVet}
                                                 message={"You are approving this new vet. It will not be active until the finance team completes their process."}
                                                 header={"Approve new vet"}/>
                            : undefined
                    }
                </div>
            </TableCell>
            <TableCell align="center">
                <div>{
                    (row.finance_processed_date !== null) ?
                        <>
                            <MdCheckCircle size={24}/><br/>
                            Merco ID: {row.finance_merco_id}
                        </>
                        :
                        <MdOutlineCancel size={24}/>
                }</div>
            </TableCell>
            <TableCell align="center">
                {
                    (row.finance_processed_date !== null && row.approved_at !== null) ?
                        <Button variant={"contained"} disabled={(!row.finance_merco_id)} onClick={() => {
                            setMigrationOpen(true);
                        }}>
                            {
                                (!row.finance_merco_id) ?
                                    "Merco ID is missing" :
                                    "Migrate vet to platform"
                            }
                        </Button>
                        :
                        <div><MdOutlineCancel size={24}/></div>
                }
                {
                    (migrationOpen === true) ?
                        <ConfirmDeleteDialog open={migrationOpen} setOpen={setMigrationOpen}
                                             fn={migrateVet}
                                             message={"You are migrating this new vet. After completion, you will be able to access it via the participating vets page."}
                                             header={"Migrate vet to platform"}/>
                        : undefined
                }
            </TableCell>
        </TableRow>
    )
}
